export const steps = {
  CREATE_ACCOUNT: {
    path: '/create-account',
  },
  BOOK: {
    path: '/book',
  },
  COMPANY_DETAILS: {
    path: '/company-details',
  },
};

export const flows = {
  legacy: [steps.BOOK, steps.CREATE_ACCOUNT],
  maintenance: [steps.BOOK],
  main: [steps.COMPANY_DETAILS, steps.BOOK, steps.CREATE_ACCOUNT],
  tax: [steps.BOOK, steps.CREATE_ACCOUNT],
};

export const REHYDRATE = 'persist/REHYDRATE';
const SET_FLOW = 'flow/setFlow';

export const setFlow = flowKey => ({ type: SET_FLOW, payload: { flowKey } });

export const flowReducer = (state = { steps: flows.main }, action = {}) => {
  switch (action.type) {
    case REHYDRATE:
      return { ...action.payload.flow, ...state };
    case SET_FLOW:
      const { flowKey } = action.payload;
      return { ...state, steps: flows[flowKey] };
    default:
      return state;
  }
};
